var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 194,
    height: 158,
    viewBox: "0 0 194 158",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M194 18.7032C186.863 21.8761 179.191 24.0196 171.141 24.9839C179.358 20.0476 185.67 12.231 188.641 2.91631C180.95 7.48808 172.432 10.8068 163.365 12.5955C156.106 4.84299 145.762 0 134.314 0C112.334 0 94.5118 17.8584 94.5118 39.8862C94.5118 43.0124 94.8639 46.0571 95.5429 48.9763C62.4639 47.313 33.1369 31.4328 13.506 7.30045C10.0799 13.1914 8.11664 20.0427 8.11664 27.3529C8.11664 41.1917 15.1433 53.4003 25.823 60.553C19.2988 60.3459 13.1616 58.5514 7.79557 55.5642C7.79105 55.7304 7.79105 55.8976 7.79105 56.0658C7.79105 75.3911 21.5108 91.5114 39.7187 95.1781C36.3789 96.09 32.8627 96.577 29.2329 96.577C26.6682 96.577 24.1754 96.3262 21.7445 95.8615C26.8099 111.708 41.5083 123.24 58.9257 123.561C45.3039 134.259 28.1427 140.636 9.49438 140.636C6.28173 140.636 3.11371 140.447 0 140.078C17.6143 151.397 38.5353 158 61.0121 158C134.221 158 174.256 97.2215 174.256 44.5104C174.256 42.7811 174.217 41.0614 174.14 39.3496C181.916 33.7269 188.663 26.7025 193.999 18.7032H194Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.a97b0634c07eca7ad6ef8648b68096ef.svg";
export { ForwardRef as ReactComponent };